// extracted by mini-css-extract-plugin
module.exports = {"content":"copy_button-module_content_1607e","tooltip":"copy_button-module_tooltip_42e3b"};